import missionApi from '@/api/mission-api'


export default {
  state: {
    missionDetail: null
  },
  getters: {
    getMissionDetail (state) {
      return state.missionDetail
    }
  },
  mutations: {
    setMissionDetail (state, value) {
      state.missionDetail = value
    }
  },
  actions: {
    GET_MISSION_DETAIL ({ commit }, { success = null, fail = null } = {}) {
      missionApi.getMissionDetail().then(res => {
        const resBody = res?.body
        if (resBody.success) {
          commit('setMissionDetail', resBody.value)
          success && success(res.body)
        } else {
          commit('setMissionDetail', null)
          fail && fail(resBody)
        }
      }).catch(err => {
        commit('setMissionDetail', null)
        fail && fail(err)
      })
    }
  },
  namespaced: true
}
